import { IsEnum, IsUUID } from 'class-validator';

export class LotAllergenDto {
  @IsUUID()
  allergenId!: string;

  @IsEnum(['CONTAINS', 'MAY_CONTAIN'])
  category!: 'CONTAINS' | 'MAY_CONTAIN';
}
